import { UPDATE_DATA_OBJECT } from '@inpart-io/devtools-vue';
import { CampaignStatus, type ICampaign } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

export const DRAFT_CAMPAIGN = 'setStatusDraft';
export const ONGOING_CAMPAIGN = 'setStatusOngoing';
export const CLOSE_CAMPAIGN = 'setStatusClose';

export const actions: ActionTree<ICampaign, unknown> = {
    async [DRAFT_CAMPAIGN](context, { campaignId, properties }: { campaignId: number; properties?: string }) {
        const newCampaign = { dobjId: campaignId, status: CampaignStatus.DRAFT };
        await context.dispatch(UPDATE_DATA_OBJECT, { dataObjectList: [newCampaign], properties });
    },

    async [ONGOING_CAMPAIGN](context, { campaignId, properties }: { campaignId: number; properties?: string }) {
        const newCampaign = { dobjId: campaignId, status: CampaignStatus.ONGOING };
        await context.dispatch(UPDATE_DATA_OBJECT, { dataObjectList: [newCampaign], properties });
    },

    async [CLOSE_CAMPAIGN](context, { campaignId, properties }: { campaignId: number; properties?: string }) {
        const newCampaign = { dobjId: campaignId, status: CampaignStatus.CLOSED };
        await context.dispatch(UPDATE_DATA_OBJECT, { dataObjectList: [newCampaign], properties });
    }
};
